import { BehaviorSubject } from 'rxjs';
import createStore from './createStore';

interface InlineHelpStore {
  pageId: string | null;
}
// eslint-disable-next-line import/no-mutable-exports
export let inlineHelpStore: BehaviorSubject<InlineHelpStore>;
export const getInlineHelpStoreValue = () => {
  if (!inlineHelpStore) {
    inlineHelpStore = createStore<InlineHelpStore>({
      pageId:null
    });
  }
  return inlineHelpStore.value;
};